<template>
  <div class="min-h-screen w-full bg-gray-100 flex flex-col">
    <!-- Loading state while auth is initializing -->
    <div v-if="isInitializing" class="fixed inset-0 flex items-center justify-center bg-white z-50">
      <div class="flex flex-col items-center gap-4">
        <div class="w-12 h-12 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
        <p class="text-gray-500 text-sm">Loading...</p>
      </div>
    </div>
    
    <div v-else class="flex-1 flex flex-col relative">
      <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200">
        <router-view></router-view>
      </main>
    </div>
    <Toast position="top-right" />
    <Toaster />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Toast from 'primevue/toast';
import Toaster from '@/components/ui/toast/Toaster.vue'

// Track initialization state
const isInitializing = ref(true)

onMounted(() => {
  // Check if auth initialization is complete
  const checkAuthInit = () => {
    if (typeof window !== 'undefined') {
      const isComplete = (window as any).__authInitComplete?.()
      if (isComplete) {
        isInitializing.value = false
      } else {
        // Check again in 100ms
        setTimeout(checkAuthInit, 100)
      }
    } else {
      isInitializing.value = false
    }
  }
  
  // Start checking after a short delay to allow main.ts to set up
  setTimeout(checkAuthInit, 50)
  
  // Fallback: hide loading after 6 seconds max (matches 5s timeout + 1s buffer)
  setTimeout(() => {
    isInitializing.value = false
  }, 6000)
})
</script>

<style>
.p-toast .p-toast-message.p-toast-message-success,
.p-toast .p-toast-message.p-toast-message-error {
  margin-top: 4rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(85, 85, 85, 0.1);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  .p-toast-message-text {
    gap: 0.1rem;
  }
  .p-toast-detail {
    font-size: 0.8rem;
  }
}

/* Add mobile viewport fixes */
html, body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
</style>